"use client";

import toast from "react-hot-toast";

export const errorToaster = (message) => {
  try {
    if (!message || typeof message !== "string") {
      toast.error("Something went wrong.");
      return;
    }

    const modifiedMessage = message.charAt(0).toUpperCase() + message.slice(1).toLowerCase();
    toast.error(modifiedMessage);
  } catch (error) {
    console.error("Toast error:", error);
    toast.error("Something went wrong.");
  }
};
